import XpPane from './XpPane';

export default XpPane;
export { XpPane };
